<template>
<div style="padding: 8px 14px;">
    <h4>{{$Jed.firstUpperTranslate('set') + " " + $Jed.firstUpperTranslate('preference', 2)}}</h4>
    <div>
        <!-- Nav tabs -->
        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active"><a href="#conn" aria-controls="conn" role="tab" data-toggle="tab">{{$Jed.firstUpperTranslate('connection')}}</a></li>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">
            <div class="well" style="background-color: white; border-top: none;">
                <div role="tabpanel" class="tab-pane active" id="conn">
<!-- _____________________________________ PROXY FORM _____________________________________ -->
                    <input-w v-if="disabled.useProxy!=true" v-model="preferences.useProxy" :configs='{"id": "useProxyCheck"}'>
                        <input id="useProxy" type="checkbox" v-model="preferences.useProxy" @change="contentChange">
                        <label for="useProxy">{{$Jed.firstUpperTranslate('use proxy')}}</label>
                    </input-w> 
                    <div v-if="preferences.useProxy" class="margin-son">
                        <div class="row" style="margin-bottom: 3px;">
                             <input-w v-model="preferences.addressProxy" :configs='{"id": "addresProxyText"}'>
                                <!-- <input id="gendate" type="text" placeholder="Enter required date" v-model="genericDateValue"> -->
                                <label class="col-xs-4 col-md-3 sublabel" for="addressProxy">{{$Jed.firstUpperTranslate('proxy address')}}</label>
                                <div  class="col-xs-8 col-md-9">
                                    <input id="addressProxy" type="text" v-model="preferences.addressProxy" @change="contentChange">
                                </div>
                            </input-w>
                        </div>
                        <div class="row">
                            <input-w v-model="preferences.portProxy" :configs='{"id": "portProxyText"}'>
                                <!-- <input id="gendate" type="text" placeholder="Enter required date" v-model="genericDateValue"> -->
                                <label class="col-xs-4 col-md-3 sublabel" for="portProxy">{{$Jed.firstUpperTranslate('proxy port')}}</label>
                                <div  class="col-xs-8 col-md-9">
                                    <input id="portProxy" type="text" v-model="preferences.portProxy" @change="contentChange">
                                </div>
                            </input-w>  
                        </div>
                        <div v-if="preferences.addressProxy && preferences.addressProxy != ''" class="row">
                            <label class="col-xs-4 col-md-3 sublabel"></label>
                            <div class="col-xs-8 col-md-9" style="color: #888; margin-top: 3px;">{{getURL()}}</div>
                        </div>
                    </div>
<!-- ____________________________________ OFFLINE FORM ____________________________________ -->
                    <input-w v-model="preferences.useOffline" :configs='{"id": "useOfflineCheck"}'>
                        <input id="useOffline" type="checkbox" v-model="preferences.useOffline" @change="contentChange">
                        <label for="useOffline">{{$Jed.firstUpperTranslate("offline use (no connection)")}}</label> <!--Consenti Utilizzo senza connessione-->
                        <p class="desc-label">{{$Jed.firstUpperTranslate("offline use explanation")}}</p> <!--Se disabilitato i documenti e i dati online sono comunque mantenuti nella cache del browser ma con vita breve-->
                    </input-w>  
                    <!-- ____________________________________ ARCHIVIAZIONE ____________________________________ -->
                    <div v-if="preferences.useOffline" class="margin-son">
                        <div class="radio-title">{{$Jed.firstUpperTranslate("storage")}}</div>
                        <p style="margin-bottom: 0px;">{{$Jed.firstUpperTranslate("storage explanation")}}</p>
                        <hr>
                        <div class="margin-self">
                            <input-w v-model="preferences.persistence" :configs='{"id": "persistenceRadio"}'>
                                <span>
                                    <input name="pers" type="radio" id="auto" value="Auto" v-model="preferences.persistence" @change="contentChange">
                                    <label for="auto">{{$Jed.firstUpperTranslate("automatic")}}</label>
                                    <p class="desc-label">{{$Jed.firstUpperTranslate("automatic explanation")}}</p> <!--i documenti online sono mantenuti nella cache con vita lunga,i dati da sincronizzare sono in IndexDB locale-->
                                </span>
                                <div v-if="preferences.persistence == 'Auto'" class="margin-son">
                                    <input-w v-model="preferences.docCat" :configs='{"id": "docCatCheck"}'>
                                        <input id="docCat" type="checkbox" v-model="preferences.docCat" @change="contentChange">
                                        <label for="docCat">{{$Jed.firstUpperTranslate("all drawings")}}</label> <!--Documenti di catalogo-->
                                        <p class="desc-label">{{$Jed.firstUpperTranslate("all drawings explanation")}} </p> <!--se attivo caricando un catalogo si avvia anche il download  dei relativi documenti; diversamente l’utente può lanciare il download dei documenti di un ramo selezionando il nodo radice-->
                                    </input-w>  
                                    <div v-if="preferences.docCat" class="margin-son">
                                        <input-w v-model="preferences.docProd" :configs='{"id": "docProdCheck"}'>
                                            <input id="docProd" type="checkbox" v-model="preferences.docProd" @change="contentChange">
                                            <label for="docProd">{{$Jed.firstUpperTranslate("all attachments")}}</label>
                                            <p class="desc-label">{{$Jed.firstUpperTranslate("all attachments explanation")}}</p><!--scarica gli allegati ai prodotti, se disabilitato scarica solo i doc grafica (svg, png)-->
                                        </input-w>  
                                        <div v-if="preferences.docProd" class="margin-self">
                                             <div class="radio-title">{{$Jed.firstUpperTranslate("attachments language")}}</div>
                                                <p style="margin-bottom: 0px;">{{$Jed.firstUpperTranslate("attachments language explanation")}}</p>
                                            <hr>
                                            <input-w v-model="everyLang" :configs='{"id": "everyLang"}'>
                                                <input id="everyLang" type="checkbox" v-model="everyLang" @change="everyLangOneBindChange">
                                                <label for="everyLang">{{$Jed.firstUpperTranslate("all")}}</label>
                                            </input-w>  
                                            <input-w v-for="l in languages" :key="l.COD" v-model="preferences.docProdLang[l.COD]" :configs='{"id": "everyLang" + l.COD}'>
                                                <input :id="'everyLang'+ l.COD" type="checkbox" v-model="preferences.docProdLang[l.COD]" @change="langChange">
                                                <label :for="'everyLang'+ l.COD">{{l.description}}</label>
                                            </input-w>  
                                        </div>
                                    </div>
                                </div>
                                <br v-else>
                                <span v-if="disabled.persistence_Manual!=true" >
                                    <input name="pers" type="radio" id="man" value="Manual" v-model="preferences.persistence" @change="contentChange">
                                    <label for="man">{{$Jed.firstUpperTranslate("manual")}}</label>
                                    <p class="desc-label">{{$Jed.firstUpperTranslate("manual storage explanation")}}</p>
                                </span>
                            </input-w>
                        </div>
                    </div>
                    <!-- ___________________________________ SINCRONIZZAZIONE ____________________________________ -->
                    <div v-if="preferences.useOffline" class="margin-son">
                        <div class="radio-title">{{$Jed.firstUpperTranslate("synchronization")}}</div>
                            <p style="margin-bottom: 0px;">{{$Jed.firstUpperTranslate("synchronization explanation")}}</p> <!--invia al server i dati modificati sul client, riceve e salva i dati modificati sul server-->
                        <hr>
                        <div class="margin-self">
                             <input-w v-model="preferences.sincro" :configs='{"id": "sincroRadio"}'>
                                <span v-if="disabled.sincro_Disabled!=true">
                                    <input name="sync" type="radio" id="dis" value="Disabled" v-model="preferences.sincro" @change="contentChange">
                                    <label for="dis">{{$Jed.firstUpperTranslate("disabled")}}</label>
                                    <p class="desc-label">{{$Jed.firstUpperTranslate("disabled explanation")}}</p>
                                    <br>
                                </span>
                                <span v-if="disabled.sincro_Manual!=true">
                                    <input name="sync" type="radio" id="sman" value="Manual" v-model="preferences.sincro" @change="contentChange">
                                    <label for="sman">{{$Jed.firstUpperTranslate("manual")}}</label>
                                    <p class="desc-label">{{$Jed.firstUpperTranslate("manual sync explanation")}}</p>
                                </span>
                                <div v-if="preferences.sincro == 'Manual'" class="margin-son">
                                    <input-w v-model="preferences.manualSyncBell" :configs='{"id": "syncBellCheck"}'>
                                        <input id="syncBell" type="checkbox" v-model="preferences.manualSyncBell" @change="contentChange">
                                        <label for="syncBell">{{$Jed.firstUpperTranslate("appropriate sync")}}</label>
                                        <p class="desc-label">{{$Jed.firstUpperTranslate("appropriate sync explanation")}}</p>
                                    </input-w>  
                                </div>
                                <br v-else>
                                <span>
                                    <input name="sync" type="radio" id="insta" value="Instant" v-model="preferences.sincro" @change="contentChange">
                                    <label for="insta">{{$Jed.firstUpperTranslate("immediate")}}</label>
                                    <p class="desc-label">{{$Jed.firstUpperTranslate("immediate explanation")}}</p> <!--effettua la sync remota immediatamente dopo la sync locale-->
                                    <br>
                                </span>
                                 <span>
                                    <input name="sync" type="radio" id="def" value="Deferred" v-model="preferences.sincro" @change="contentChange">
                                    <label for="def">{{$Jed.firstUpperTranslate("deferred")}}</label>
                                    <p class="desc-label">{{$Jed.firstUpperTranslate("deferred explanation")}}</p> <!--effettua la sync a intervalli regolari indipendentemente dalla sync locale-->
                                </span>
                                <div v-if="preferences.sincro == 'Deferred'" class="margin-son">
                                     <div class="row" style="margin-bottom: 3px;">
                                        <input-w v-model="preferences.deferredInterval" :configs='{"id": "defIntMin"}'>
                                            <label class="col-xs-4 col-md-3 sublabel" for="defInt">{{$Jed.firstUpperTranslate("interval")}}</label>
                                            <div  class="col-xs-8 col-md-9">
                                                <input id="defInt" type="number" v-model="preferences.deferredInterval"> {{$Jed.firstUpperTranslate("min.")}}
                                                <p style="margin-top: 2px;">{{$Jed.firstUpperTranslate("interval explanation")}}</p>
                                            </div>
                                        </input-w>
                                    </div>  
                                </div>
                            </input-w>
                        </div>
                    </div>
                    <button class="btn btn-primary-info" @click="reset()">{{$Jed.firstUpperTranslate("restore predefined configs")}}</button>
                    <button class="btn btn-primary-default" style="float: right;" @click="save()">{{$Jed.firstUpperTranslate("save")}}</button>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>

    import { eventBus } from "../../eventbus.js";
    import InputW from '../dynamic/inputWrapper/inputWrapper.vue'

    export default {
        mounted: function(){
            // TODO: preference on proxy change
            var source = null
            try {
                this.collection = this.$root.dataReferences.getCollection("preferences");
                // preferibilmente, leggo le preferenze dal record salvato su indexDB, e non dall'oggetto di sessione
                // in questo modo, ad un secondo settaggio delle preferenze, quelle scelte risultano quelle salvate (anche se non è stato fatto refresh e potrebbero non essere ancora attive)
                source = this.collection.find({"id": this.$root.token.idUtente})[0];
            } catch(err){
                console.log("error finding user record preference")
                console.log(err)
                source = this.$root.preferences;
            }

            for(var prop in source){
                // non salvo direttamente nell'oggetto di sessione, così i cambiamenti che sto facendo non incidono da subito su altri processi in esecuzione (sincronizzazione)
                if(prop != "docProdLang"){ // lingue degli allegato da scaricare - mappati a parte
                     this.preferences[prop] = source[prop];
                }
            }

            if(!this.disabled) this.disabled = {};

            if(source.docProdLang){
                this.preferences.docProdLang = {};
                if(source.docProdLang == "all"){
                    this.everyLang = true;
                    for( var i = 0; i < this.languages.length; i++ ){
                        this.preferences.docProdLang[this.languages[i].COD] = true;
                    }
                } else {
                    this.everyLang = false;
                    for( var i = 0; i < this.languages.length; i++ ){
                        this.preferences.docProdLang[this.languages[i].COD] = false;
                    }
                    var checked = source.docProdLang.split(";");
                    for( var i = 0; i < checked.length; i++) {
                        this.preferences.docProdLang[checked[i]] = true;
                    }
                    this.langChange()
                }
            }

            console.log(this.preferences)
            this.$nextTick(function(){
                this.$root.closeSidebar();
                this.$forceUpdate();
            })
        },
        components: {
            InputW
        },
        data: function(){
            var vm = this;
            return {
                collection: null,
                disabled: front_end_configs.disable_preferences,
                preferences: {},
                needF5: ["useOffline", "persistence", "docCat", "docProd", "docProdLang"],
                needReCache: ["useOffline", "persistence", "docCat", "docProd", "docProdLang"],
                needRestart: false,

                languages: languages,
                everyLang: true
            }
        },
        methods: {
            everyLangOneBindChange(){
                for(var prop in this.preferences.docProdLang){
                    this.preferences.docProdLang[prop] = this.everyLang;
                    this.contentChange()
                }
            },
            langChange: function(){
                var every = true;
                for(var prop in this.preferences.docProdLang){
                    if(!this.preferences.docProdLang[prop]){
                        every = false;
                        break;
                    }
                }
                this.everyLang = every;
                this.contentChange()
            },
            contentChange: function(){
                this.$forceUpdate();
            },
            getURL: function(){
                return this.preferences.addressProxy + (this.preferences.portProxy ? (":" + this.preferences.portProxy) : ""); 
            },
            save: function(){
                try {   
                    //saved contiente il riferimento al record salvato su indexedDB
                    var saved = this.collection.find({"id": this.$root.token.idUtente})[0];
                    this.needRestart = false;
                    this.needRedownload = false;
                    for(var prop in this.preferences){
                        if(prop != "docProdLang"){
                            // nonstante abbia letto le preferenze dal record su indexDB, il controllo dei cambiamenti lo faccio sull'oggetto di sessione...
                            // in quanto successivi ripristini di alcune configurazioni critiche, non risultino cambiate (visto che non è stato ancora fatto un refresh)
                            if(this.$root.preferences[prop] != this.preferences[prop]){
                                // per ogni prop modificata
                                var found = this.needF5.indexOf(prop)
                                if(found != -1 && !this.$root.BLOCK_NAVIGATION){
                                    // se necessita un restart, non la salvo nelle preferenze di sessione 
                                    this.needRestart = true;
                                    // se sono alla prima scelte delle preferenze, tuttavia, applico subito ogni modifica
                                } else {
                                    // altrimenti, la salvo anche nelle preferenze di sessione
                                    this.$root.preferences[prop] = this.preferences[prop];
                                }
                                
                                // eseguo un'ulteriore analisi nella proprietà modificata
                                found = this.needReCache.indexOf(prop)
                                if(found != -1 && !this.$root.BLOCK_NAVIGATION){
                                    // se la modifica necessita che venga rieseguita la procedura di download..
                                    // resetto i record informativi sulla cache
                                    this.needRedownload = true;
                                }
                            }
                            // in ogni caso, salvo le modifiche su indexedDB
                            saved[prop] = this.preferences[prop];
                        } else {
                            // docProdLang ha un mapping diverso, ma la logica è la stessa di sopra
                            var saving = [];
                            var all = true;
                            for(var lang in this.preferences.docProdLang){
                                if(this.preferences.docProdLang[lang]){
                                    saving.push(lang);
                                } else {
                                    all = false;
                                }
                            }
                            saving = all ? "all" : saving.join(";") // saving = "all" || "ITA;ENG..."
                            if(this.$root.preferences.docProdLang != saving && !this.$root.BLOCK_NAVIGATION){
                                this.needRestart = true;
                                this.needRedownload = true;
                            } else {
                                this.$root.preferences.docProdLang = saving;
                            }
                            saved.docProdLang = saving;
                        }
                    }
                    saved.savedOnce = true;
                    this.collection.update(saved);
            
                    console.log(this.$root.preferences)
                    console.log(saved)
                    if(this.needRestart){
                        eventBus.$emit("alert", {type: "success", message: "<div>"+ this.$Jed.firstUpperTranslate('%1$s successfully saved', 2, {key: 'preference', n: 2}, 'female') +"</div>"+this.$Jed.firstUpperTranslate('warning', null)+"! " +  this.$Jed.firstUpperTranslate('some of the changes need a refresh to be applied', null)})
                    } else {
                        eventBus.$emit("alert", {type: "success", message: this.$Jed.firstUpperTranslate('%1$s successfully saved', 2, {key: 'preference', n: 2}, 'female')})
                    }
                    if(this.needRedownload){
                        this.$root.resetCache();
                    }
                    if(this.$root.BLOCK_NAVIGATION){
                        this.$root.BLOCK_NAVIGATION = false;
                        eventBus.$emit("doneFirstPreferences");
                    }
                } catch(err){
                    eventBus.$emit("alert", {type: "error", message: this.$Jed.firstUpperTranslate('an error has occured while saving settings', null)})
                    console.log("ERROR OVERRIDING PREFERENCES");
                    console.log(err)
                }
            },
            reset: function(){
                var vm = this;
                var ok = function(){
                    console.log(front_end_configs.default_preferences)
                    for( var prop in front_end_configs.default_preferences ){
                        vm.preferences[prop] = front_end_configs.default_preferences[prop];
                    }
                    console.log(vm.preferences)
                    vm.$forceUpdate();
                    vm.save();
                }
                var no = function(){
                }
                var e = {
                    message: this.$Jed.firstUpperTranslate('do you want to restore default settings?', null),
                    ok: ok,
                    no: no
                }
                eventBus.$emit("confirm", e)
            }
        }
    }
</script>
<style scoped>
    .margin-son {
        margin-left: 15%;
        margin-bottom: 10px;
    }
    .margin-self {
        margin-left: 5%;
        margin-bottom: 10px;
    }
    hr {
        margin: 5px 0px !important;
    }
    label.sublabel {
        text-align: right;
    }
    p.desc-label {
        margin-left: 15px;
    }
    .radio-title {
        margin-top: 8px;
        font-size: large; 
        font-weight: 300
    }
</style>


// WEBPACK FOOTER //
// src/components/views/Preferences.vue?422e3f90